import { useEffect, useState } from 'react';
import { getLastPunch } from '../../services/FunctionKeysService';
import { Box, Grid, Typography } from '@mui/material';
import CommonUtil from '../../util/CommonUtils';
import CustomOutlinedButton from '../../components/CustomOutlined';
import CustomFilledButton from '../../components/CustomFilledButton';
import { PUNCH_INFO_PAGE, REACT_FUNCTION_KEY_SCREEN } from '../../constants/ReactEndPoints';
import { useNavigate } from 'react-router-dom';
import { getFormattedLocalDate } from '../../util/helperFunction';
import { useTranslation } from 'react-i18next';

const PunchInfo = () => {
  const {t} = useTranslation();
  const [lastPunch, setLastPunch] = useState({});
  const [rawLastPunchDate, setRawLastPunchTimeStamp] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchLastPunchData();
  }, []);



  const fetchLastPunchData = async () => {
    try {
      const res = await getLastPunch();
      if (res.status === 200) {
        setLastPunch(res?.data);
        setRawLastPunchTimeStamp(res?.data?.punchDate);
      }
    } catch (error) {
      console.error("Error in fetching last punch", error);
    }
  };

  const langFormattedDate = rawLastPunchDate 
    ? getFormattedLocalDate(rawLastPunchDate)
    : "";

  return (
    <Grid container justifyContent={'center'}>
      <Grid item container direction="column" sx={{ maxWidth: '550px', paddingTop: '30px' }}>

        {/* Heading */}
        <Grid item container justifyContent={'center'} sx={{ paddingBottom: '20px' }}>
          <Typography variant='lastPunchLabel1'>{t("punchInfo.title")}</Typography>
        </Grid>

        {/* contents */}
        <Grid item container sx={{ width: '100%' }} justifyContent={'center'} marginLeft={'100px'}>
          <Box display={'flex'} flexDirection={'column'} sx={{ width: '100%' }} rowGap={'10px'}>
            {/*Punch Date/ Time*/}
            <Box display={'flex'}>
              <Typography
                variant='lastPunchLabel2'
                sx={{
                  width: '30%',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
               {t("punchInfo.labels.punchDateTime")}
              </Typography>

              <Typography
                variant='lastPunchLabel3'
                sx={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textAlign: 'left'
                }}
              >
                {langFormattedDate}
              </Typography>
            </Box>

            {/*Attendance State */}
            <Box display={'flex'}>
              <Typography
                variant='lastPunchLabel2'
                sx={{
                  width: '30%',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                 {t("punchInfo.labels.attendanceState")}
              </Typography>

              <Typography
                variant='lastPunchLabel3'
                sx={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textAlign: 'left'
                }}
              >
                {CommonUtil.getAttendanceState(lastPunch?.eventCode).split(" ")[0] === "undefined" ? "" : CommonUtil.getAttendanceState(lastPunch?.eventCode)}
              </Typography>
            </Box>

            {/*Verifying Mode*/}
            <Box display={'flex'}>
              <Typography
                variant='lastPunchLabel2'
                sx={{
                  width: '30%',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
               {t("punchInfo.labels.verifyingMode")}
              </Typography>

              <Typography
                variant='lastPunchLabel3'
                sx={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textAlign: 'left'
                }}
              >
                {CommonUtil.getPunchMode(lastPunch?.verifyType).split(" ")[0] === "undefined" ? "" : CommonUtil.getPunchMode(lastPunch?.verifyType)}
              </Typography>
            </Box>

          </Box>
        </Grid>
      </Grid>

      {/* Buttons */}
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          bottom: "20px",
          px: "15px",
        }}
        display="flex"
        justifyContent="space-between"
      >
        <CustomOutlinedButton
          onBtnClick={() => navigate(REACT_FUNCTION_KEY_SCREEN)}
          title={t("punchInfo.buttons.back")}
        />
        <CustomFilledButton
          onBtnClick={() => navigate(PUNCH_INFO_PAGE)}
          title={t("punchInfo.buttons.viewAll")}
        />
      </Box>

    </Grid>
  );
};

export default PunchInfo;
